// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__AgKGU","noInteraction":"EventWrapper_noInteraction__29xOu","pointerPassthrough":"EventWrapper_pointerPassthrough__3rzzg"};